import React, { useState,} from "react";
import { Container, Table, Button, Badge, Modal, Form, Row, Col } from "react-bootstrap";
import { FileEarmarkExcel } from "react-bootstrap-icons";
import * as XLSX from 'xlsx';
import "../App.css";

const TabelPartizi = ({ titlu, date, laStergere, laEditare, tema, user }) => {
  const [show, setShow] = useState(false);
  const [partidaCurenta, setPartidaCurenta] = useState(null);
  const [filterText, setFilterText] = useState("");



  // 2. Logica combinată: Permisiuni + Căutare
  const dateFiltrate = (date || []).filter((item) => {
    // 1. Dacă nu avem user, nu putem aplica filtrarea de securitate.
    // Dacă ești în faza de testare, poți returna 'true' pentru a vedea datele.
    if (!user) return true;

    const esteAdmin = user?.rol === "administrator";
    const apartineOcolului =
      item.ocol?.toString().toLowerCase().trim() ===
      user?.ocol?.toString().toLowerCase().trim();

    if (!esteAdmin && !apartineOcolului) return false;

    // 2. Filtrare căutare
    if (!filterText) return true;
    const cautare = filterText.toLowerCase().trim();

    return (
      item.fond?.toString().toLowerCase().includes(cautare) ||
      item.sumal?.toString().toLowerCase().includes(cautare) ||
      item.ocol?.toString().toLowerCase().includes(cautare) ||
      item.natura?.toString().toLowerCase().includes(cautare)
    );
  });

  const handleClose = () => setShow(false);

  const handleShow = (partida) => {
    setPartidaCurenta({ ...partida });
    setShow(true);
  };

  // --- LOGICA DE EXPORT ÎN EXCEL---
  const exportaExcel = () => {
    const dateExport = dateFiltrate.map((item) => ({
      "Ocol Silvic": item.ocol,
      Partida: item.numarPartida
        ? `${item.fond} (${item.numarPartida})`
        : item.fond,
      SUMAL: item.sumal,
      UP: `${item.up || "-"}`,
      ua: `${item.ua || "-"}`,
      Natura: item.natura,
      "Vol. Brut (mc)": item.volBrut,
      "Val. Totală (RON)": parseFloat(item.valTotal || 0),
      Stare: item.stare === "disponibil" ? "Disponibil" : "Contractat",
      "T inc I": formateazaData(item.termenIncI),
      "T sf I": formateazaData(item.termenSfI),
      "T inc II": formateazaData(item.termenIncII),
      "T sf II": formateazaData(item.termenSfII),
    }));

    const ws = XLSX.utils.json_to_sheet(dateExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Partizi");
    XLSX.writeFile(
      wb,
      `${titlu.replace(/\s+/g, "_")}_${new Date().toLocaleDateString()}.xlsx`,
    );
  };

const tratezEditare = (e) => {
  e.preventDefault();

  // Conversie sigură pentru toate câmpurile numerice
  const dateUpdate = {
    ...partidaCurenta,
    volBrut: Number(partidaCurenta.volBrut) || 0,
    suprafata: Number(partidaCurenta.suprafata) || 0,
    valTotal: Number(partidaCurenta.valTotal) || 0,
  };

  laEditare(partidaCurenta.id, dateUpdate);
  handleClose();
};

const formateazaData = (ds) => {
  if (!ds || ds === "0000-00-00") return "-";
  const data = new Date(ds);
  return isNaN(data.getTime()) ? "-" : data.toLocaleDateString("ro-RO");
};

  // Helper pentru Divider în Modal
  const SectiuneDivider = ({ text }) => (
    <div className="d-flex align-items-center my-3">
      <span className="text-secondary fw-bold small text-uppercase me-2">
        {text}
      </span>
      <div className="flex-grow-1 border-bottom opacity-25"></div>
    </div>
  );

  return (
    <Container fluid className="mt-4">
      <div className="d-flex align-items-center border-bottom mb-3 pb-2">
        <h3 className="text-success fw-bold mb-0">{titlu}</h3>
        <Form.Control
          type="text"
          placeholder="Caută după fond, sumal sau ocol..."
          className="w-25 me-3 ms-4"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <Button
          variant="outline-success"
          className="ms-auto d-flex align-items-center"
          onClick={exportaExcel}
        >
          <FileEarmarkExcel size={20} className="me-2" />
          Exportă în Excel
        </Button>
      </div>

      {dateFiltrate.length === 0 ? (
        <p className="text-muted">Nu există partizi înregistrate.</p>
      ) : (
        <Table
          striped
          bordered
          hover
          responsive
          size="sm"
          className="shadow-sm align-middle text-center"
        >
          <thead>
            <tr className="small text-uppercase">
              <th>#</th>
              <th>Ocol</th>
              <th>Fond / SUMAL</th>
              <th>UP / UA</th>
              <th>Natura</th>
              <th>Vol. Brut</th>
              <th>Val. Totală</th>
              <th>Stare</th>
              <th>T inc I</th>
              <th>T sf I</th>
              <th>T inc II</th>
              <th>T sf II</th>

              <th className="text-center">Acțiuni</th>
            </tr>
          </thead>
          <tbody className="small">
            {dateFiltrate.map((item, index) => (
              <tr key={item.id || index}>
                <td>{index + 1}</td>
                <td>{item.ocol}</td>
                <td>
                  <div className="fw-bold">{item.fond || "-"}</div>
                  <div className="text-muted" style={{ fontSize: "0.8rem" }}>
                    {item.sumal || "-"}
                  </div>
                </td>
                <td>
                  {item.up || "-"} / {item.ua || "-"}
                </td>
                <td>{item.natura}</td>
                <td className="fw-bold">{item.volBrut} mc</td>
                <td>
                  {parseFloat(item.valTotal || 0).toLocaleString("ro-RO")} RON
                </td>
                <td>
                  {item.stare === "disponibil" ? (
                    <Badge bg="success">Disponibil</Badge>
                  ) : (
                    <Badge bg="info" text="dark">
                      Contractat
                    </Badge>
                  )}
                </td>
                <td>{formateazaData(item.termenIncI)}</td>
                <td>{formateazaData(item.termenSfI)}</td>
                <td>{formateazaData(item.termenIncII)}</td>
                <td>{formateazaData(item.termenSfII)}</td>

                <td className="text-center">
                  {item.stare === "disponibil" ? (
                    <>
                      <Button
                        variant="outline-warning"
                        size="sm"
                        className="me-1"
                        onClick={() => handleShow(item)}
                      >
                        Editare
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => laStergere(item)}
                      >
                        Ștergere
                      </Button>
                    </>
                  ) : (
                    <Badge bg="info" text="dark">
                      Partidă contractată
                    </Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* MODAL EDITARE PARTIDĂ */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header
          closeButton
          className={tema === "dark" ? "bg-dark text-white" : ""}
        >
          <Modal.Title>Editează Partida: {partidaCurenta?.fond}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={tratezEditare}>
          <Modal.Body className={tema === "dark" ? "bg-dark text-white" : ""}>
            {partidaCurenta && (
              <>
                <SectiuneDivider text="Identificare" />
                <Row className="g-2">
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Nr. Fond
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="text"
                        value={partidaCurenta.fond}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            fond: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">SUMAL</Form.Label>
                      <Form.Control
                        size="sm"
                        type="text"
                        value={partidaCurenta.sumal}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            sumal: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">UP</Form.Label>
                      <Form.Control
                        size="sm"
                        type="text"
                        value={partidaCurenta.up}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            up: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">UA</Form.Label>
                      <Form.Control
                        size="sm"
                        type="text"
                        value={partidaCurenta.ua}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            ua: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <SectiuneDivider text="Date Tehnice & Volume" />
                <Row className="g-2">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Natura Lucrării
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="text"
                        value={partidaCurenta.natura}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            natura: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Vol. Brut (mc)
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="number"
                        value={partidaCurenta.volBrut}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            volBrut: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Suprafață (ha)
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="number"
                        step="0.01"
                        value={partidaCurenta.suprafata}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            suprafata: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <SectiuneDivider text="Financiar & Termene" />
                <Row className="g-2">
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Valoare (RON)
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="number"
                        value={
                          partidaCurenta.valTotal
                            ? parseFloat(partidaCurenta.valTotal).toFixed(2)
                            : 0
                        }
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            valTotal: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Termen Inc I
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="date"
                        value={partidaCurenta.termenIncI}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            termenIncI: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Termen Sf I
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="date"
                        value={partidaCurenta.termenSfI}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            termenSfI: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Termen inc II
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="date"
                        value={partidaCurenta.termenIncII}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            termenIncII: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Termen sf II
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="date"
                        value={partidaCurenta.termenSfII}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            termenSfII: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="small fw-bold">
                        Transport
                      </Form.Label>
                      <Form.Select
                        size="sm"
                        value={partidaCurenta.transport}
                        onChange={(e) =>
                          setPartidaCurenta({
                            ...partidaCurenta,
                            transport: e.target.value,
                          })
                        }
                      >
                        <option value="cuTransport">Cu transport</option>
                        <option value="faraTransport">Fără transport</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer
            className={tema === "dark" ? "bg-dark border-secondary" : ""}
          >
            <Button variant="secondary" onClick={handleClose} size="sm">
              Anulează
            </Button>
            <Button variant="success" type="submit" size="sm">
              Salvează Modificările
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};;

export default TabelPartizi;
